/* ============================================
   AANYA A/B Testing Framework
   Lightweight variant assignment via localStorage + experiment tracking
   Usage: Include once in theme.liquid or any template
   API: window.AanyaAB.test('experiment-name', { control: 'A', variants: ['B', 'C'] })
   ============================================ */

(function () {
  var STORAGE_KEY = 'aanya_ab';
  var _experiments = {};
  try {
    _experiments = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {}

  function hashCode(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function getUserId() {
    var uid = null;
    try {
      uid = localStorage.getItem('aanya_uid');
      if (!uid) {
        uid = 'u_' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('aanya_uid', uid);
      }
    } catch (e) {
      uid = 'u_' + Math.random().toString(36).substr(2, 9);
    }
    return uid;
  }

  function assignVariant(experimentName, variants, force) {
    if (_experiments[experimentName] && !force) {
      return _experiments[experimentName];
    }
    var uid = getUserId();
    var hash = hashCode(uid + experimentName);
    var idx = hash % variants.length;
    var chosen = variants[idx];
    _experiments[experimentName] = chosen;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(_experiments));
    } catch (e) {}
    return chosen;
  }

  function track(experimentName, variant, event, data) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', event, {
        experiment_name: experimentName,
        variant: variant,
        custom: data || {}
      });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('trackCustom', 'AB_' + event, {
        experiment: experimentName,
        variant: variant
      });
    }
  }

  window.AanyaAB = {
    test: function (name, opts) {
      var allVariants = [opts.control].concat(opts.variants || []);
      var variant = assignVariant(name, allVariants, opts.force);
      return {
        name: name,
        variant: variant,
        isControl: variant === opts.control,
        track: function (event, data) {
          track(name, variant, event, data);
        },
        apply: function (classes) {
          if (classes && classes[variant]) {
            var el = document.querySelector('[data-ab-' + name + ']');
            if (el) el.classList.add(classes[variant]);
          }
        }
      };
    },
    getVariant: function (name) {
      return _experiments[name] || null;
    },
    reset: function () {
      _experiments = {};
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ab-experiment]').forEach(function (el) {
      var expName = el.getAttribute('data-ab-experiment');
      var control = el.getAttribute('data-ab-control') || 'A';
      var variants = (el.getAttribute('data-ab-variants') || 'B').split(',');
      var result = window.AanyaAB.test(expName, { control: control, variants: variants });
      el.setAttribute('data-ab-active', result.variant);
      el.classList.add('ab-variant-' + result.variant);
      if (result.isControl) el.classList.add('ab-control');
    });
  });
})();
